import { render } from "./booker.vue?vue&type=template&id=c31fbd1a&scoped=true"
import script from "./booker.vue?vue&type=script&lang=js"
export * from "./booker.vue?vue&type=script&lang=js"

import "./booker.vue?vue&type=style&index=0&id=c31fbd1a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c31fbd1a"

export default script